import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import pq from 'pqgrid';
import { EmailQuestionFormParameters } from '../models/EmailQuestionFormParameters';
import { LocationType } from '../models/Enums';
import { TicketMaintenanceParameters } from '../models/TicketMaintenanceParameters';
import { PqgridComponent } from '../pqgrid/pqgrid.component';
import { TicketMaintenanceService } from '../services/ticket-maintenance.service';
import { TicketMaintenanceLoadItem } from '../models/TicketMaintenanceLoadItem';
import * as $ from 'jquery';

@Component({
    selector: 'tm-loads',
    templateUrl: 'tm-loads.component.html',
    styles: [
        `.custom-red {
          background-color: red !important;
        }

        .custom-green {
            background-color: green !important;
        }
   `
    ],
    standalone: false
})
export class TMLoadsComponent {
  @Input() loads: TicketMaintenanceLoadItem[];
  @Input() ticketMaintenanceParameters: TicketMaintenanceParameters;
  @ViewChild('loadsGrid') loadsGrid: PqgridComponent;
  emailQuestionForm: EmailQuestionFormParameters = new EmailQuestionFormParameters();
  emailQuestionFormId: string = 'emailQuestionModalTM'
  loadsOptions: pq.gridT.options;
  @Output() filteredDataEmit: EventEmitter<TicketMaintenanceLoadItem[]> = new EventEmitter<TicketMaintenanceLoadItem[]>();
  @Output() updateTotalCounterEmit: EventEmitter<number> = new EventEmitter<number>();
  selectedIndexes = [];
  errorMessage: string;
  filteredCount: number = -1;

  constructor(private _ticketMaintenanceService: TicketMaintenanceService) { }

  loadsColumns = [
    {
      title: "<input type='checkbox' style='margin-left: 10px;'/>",
      cb: {
        all: true,
        header: true
      },
      width: 30, type: "checkbox", dataIndx: "include", resizable: false, editable: true, align: 'center',
      sortable: false, nodrag: true, dataType: "bool", editor: false,
    },
    {
      title: "", width: 30, dataType: "html", resizable: false, editable: false, sortable: false, nodrag: true,
      render: function (ui) {
        return '<a href="#" class="grid-icon-btn question-email-btn" data-bs-toggle="modal" data-bs-target="#emailQuestionModalTM" title="Email Question"><i class="fa-solid fa-question-circle fa-lg"></i></a>';
      }
    },
    { title: "Loc", width: 80, dataType: "string", dataIndx: "locCode", editable: false, filter: { crules: [{ condition: "contain" }] } },
    {
      title: "Load Date", width: 120, dataType: "date", dataIndx: "loadDate", editable: false,
      format: 'm/d/yy',
      cls: 'pq-calendar pq-side-icon',
      editor: {
        type: 'textbox',
        init: this.dateEditor,
        getData: function (ui) {
          //convert from column format to native js date format "mm/dd/yy"
          var dt = $.datepicker.parseDate(ui.column.format, ui.$cell.find("input").val());
          return $.datepicker.formatDate("mm/dd/yy", dt);//don't change it.
        }
      },
      filter: { crules: [{ condition: "contain" }] }
    },
    {
      title: "Delivery Date", width: 120, dataType: "string", dataIndx: "deliveryDate", editable: false,
      format: 'm/d/yy',
      cls: 'pq-calendar pq-side-icon',
      editor: {
        type: 'textbox',
        init: this.dateEditor,
        getData: function (ui) {
          //convert from column format to native js date format "mm/dd/yy"
          var dt = $.datepicker.parseDate(ui.column.format, ui.$cell.find("input").val());
          return $.datepicker.formatDate("mm/dd/yy", dt);//don't change it.
        }
      },
      filter: { crules: [{ condition: "contain" }] }
    },
    { title: "Load Number", width: 120, dataType: "string", dataIndx: "loadNumber", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Trucker", width: 250, dataType: "string", dataIndx: "trucker", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Origin ID", width: 100, dataType: "string", dataIndx: "originID", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Origin Customer", width: 250, dataType: "string", dataIndx: "originCustomer", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Origin", width: 250, dataType: "string", dataIndx: "origin", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Origin City", width: 150, dataType: "string", dataIndx: "originCity", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Destination ID", width: 130, dataType: "string", dataIndx: "destinationID", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Destination Customer", width: 250, dataType: "string", dataIndx: "destinationCustomer", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Destination", width: 250, dataType: "string", dataIndx: "destination", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Dest City", width: 150, dataType: "string", dataIndx: "destinationCity", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Comm", width: 80, dataType: "string", dataIndx: "commodity", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "P/A", width: 80, type: "checkbox", dataType: "bool", dataIndx: "preAdvise", resizable: false, editable: false, align: 'center', editor: false },
    { title: "Dlvd", width: 80, type: "checkbox", dataType: "bool", dataIndx: "delivered", resizable: false, editable: false, align: 'center', editor: false },
    {
      title: "Delivered Date", width: 120, dataType: "string", dataIndx: "deliveredDate", editable: false,
      format: 'mm/dd/yy',
      cls: 'pq-calendar pq-side-icon',
      filter: { crules: [{ condition: "contain" }] }
    },
    { title: "Ticket", width: 120, dataType: "string", dataIndx: "ticketNumber", editable: true, filter: { crules: [{ condition: "contain" }] } },
    { title: "F/S", width: 80, type: "checkbox", dataType: "bool", dataIndx: "finalSettled", resizable: false, editable: false, align: 'center', editor: false },
    { title: "Rate", width: 120, dataType: "string", dataIndx: "rate", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Load Num Desc", width: 150, dataType: "string", dataIndx: "loadNumDesc", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Note", width: 180, dataType: "string", dataIndx: "notes", editable: true, filter: { crules: [{ condition: "contain" }] } },
    { title: "Purchase Contract", width: 100, dataType: "string", dataIndx: "purchaseContract", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Dest Unload", width: 120, dataType: "string", dataIndx: "destUnload", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Trucker ID", width: 110, dataType: "string", dataIndx: "truckerID", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "MA Notes", width: 180, dataType: "string", dataIndx: "maNotes", editable: true, filter: { crules: [{ condition: "contain" }] } },
    { title: "Sales Contract #", width: 100, dataType: "string", dataIndx: "salesContract", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Entered By", width: 150, dataType: "string", dataIndx: "enteredBy", editable: false, filter: { crules: [{ condition: "contain" }] } },
    { title: "Load Id", width: 100, dataType: "string", dataIndx: "loadId", editable: false, filter: { crules: [{ condition: "contain" }] } }
  ];

  ngOnInit(): void {
    const selfThis = this;

    this.loadsOptions = this.getLoadOptions([]);

    this.loadsOptions.colModel[1].postRender = function (ui) {
      var scheduleId = ui.rowData.scheduleId;
      var dispatchId = ui.rowData.dispatchId;
      var $cell = this.getCell(ui);
      var $emailQuestionBtn = $cell.find('.question-email-btn');
      $emailQuestionBtn.on('click', function () {
        selfThis.getEmailQuestionDetails(scheduleId, dispatchId);
        return false;
      });
    }

    this.loadsOptions.dataModel.data = this.loads;

    setTimeout(() => {
      this.setGridHeight();
    }, 1)

    // hook up change event on grid
    this.loadsOptions.change = function (evt, ui) {
      selfThis.gridChange(evt, ui);
    }

    this.updateRecordCountDisplay();
  }

  getLoadOptions(data: TicketMaintenanceLoadItem[]): pq.gridT.options {
    return {
      menuIcon: false,
      showTop: false,
      reactive: true,
      roundCorners: true,
      locale: "en",
      height: "flex",
      fillHandle: "",
      freezeCols: 1,
      resizable: true,
      numberCell: { show: false },
      colModel: this.loadsColumns,
      animModel: { on: true },
      dataModel: { data },
      editModel: { clicksToEdit: 1 },
      sortModel: {
        cancel: true,
        type: "local",
        single: false,
        space: false
      },
      filterModel: {
        header: true,
        menuIcon: false
      },
      postRenderInterval: -1,
      rowInit: this.initializeRowStyles,
      filter: this.handleFilterEvent.bind(this)
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setGridHeight();
  }


  initializeRowStyles(ui: any): { style?: string } {
    const rowData = ui.rowData;
    if (rowData.include) {
      return {
        style: "background: linear-gradient(to bottom, #a3d49b, #6fba75)"
      };
    }
    if (rowData.preAdvise && rowData.delivered && rowData.finalSettled) {
      return {
        style: "background : #ffd700"
      };
    }
    else if (rowData.finalSettled) {
      return {
        style: "background : #ffd700"
      };
    }
    else if (rowData.delivered) {
      return {
        style: "background : #ffa07a"
      };
    }
    else if (rowData.preAdvise) {
      return {
        style: "background : #009aee"
      };
    } else
      return {};
  }

  handleFilterEvent(): void {
    const filteredData = this.loadsOptions.dataModel.data as TicketMaintenanceLoadItem[];
    if (filteredData) {
      this.filteredDataEmit.emit(filteredData);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loads'] || changes['ticketMaintenanceParameters']) {
      if (this.loadsOptions) {
        this.loadsOptions.dataModel.data = this.loads;
        this.setGridHeight();
        this.updateRecordCountDisplay();

      }
    }
  }

  setGridHeight() {
    if (this.loadsGrid) {
      let gridPosition = this.loadsGrid.div.nativeElement.getBoundingClientRect();
      this.loadsOptions.height = window.innerHeight - gridPosition.top - 35;
    }
  }

  clearSelectedItems() {
    const items = this.loadsOptions.dataModel.data.filter((item: TicketMaintenanceLoadItem) => item.isSelected);
    items.forEach((element: TicketMaintenanceLoadItem) => {
      element.isSelected = false;
      element.include = false;
    });
  }

  gridChange(evt, ui) {
    let isSelectChange = ui.updateList[0].newRow.selected !== undefined;
    if (!isSelectChange) {
      ui.updateList.forEach(element => {
        let load = element.rowData;
        const loadItem = {
          maNotes: load.maNotes ?? "",
          ticketNumber: load.ticketNumber ?? "",
          loadId: load.loadId,
          notes: load.notes ?? ""
        }
        this._ticketMaintenanceService.saveLoadTM(loadItem).subscribe({
          next: data => {
            if (data) {
            }
          },
          error: err => this.errorMessage = err
        });
      });
    }
    let index = ui.updateList[0].rowIndx;
    let loadItem = this.loadsOptions.dataModel.data[index] as TicketMaintenanceLoadItem;
    if (loadItem) {
      loadItem.isSelected = !loadItem.isSelected;
      this.handleRowSelection(loadItem.isSelected, index);
    }
  }

  handleRowSelection(isSelected: boolean, index: number): void {
    const indexPosition = this.selectedIndexes.indexOf(index);
    if (isSelected && indexPosition === -1) {
      this.selectedIndexes.push(index);
    } else if (!isSelected && indexPosition !== -1) {
      this.selectedIndexes.splice(indexPosition, 1);
    }
  }

  updateRecordCountDisplay(): void {
    const recordCount = this.loadsOptions.dataModel?.data?.length;
    this.updateTotalCounterEmit.emit(recordCount);
  }

  getSelectedItems(): number[] {
    return this.loadsOptions.dataModel.data.filter((item: TicketMaintenanceLoadItem) => item.include).map((c: any) => c.loadId);
  }

  getEmailQuestionDetails(scheduleId: number, dispatchId: number) {
    let parms = new EmailQuestionFormParameters()
    parms.scheduleId = scheduleId;
    parms.dispatchId = dispatchId;
    parms.periodStartDate = this.ticketMaintenanceParameters.startDate;
    parms.periodEndDate = this.ticketMaintenanceParameters.endDate;
    parms.locationType = LocationType.Destination;
    this.emailQuestionForm = parms;
  }

  clearFilters() {
    this.loadsGrid.grid.reset({ filter: true });
  }

  clearSorting() {
    this.loadsGrid.grid.reset({ sort: true });
  }

  exportExcel(): void {
    const allData = [];
    let loads: TicketMaintenanceLoadItem[] = this.loadsOptions.dataModel.data as TicketMaintenanceLoadItem[];

    loads.forEach((element) => {
      allData.push({
        loadId: element.loadId,
        locCode: element.locCode,
        loadDate: element.loadDate,
        deliveryDate: element.deliveryDate,
        deliveryTime: element.deliveryTime,
        loadNumber: element.loadNumber,
        ticket: element.ticketNumber,
        destination: element.destination,
        finalSettled: element.finalSettled ? 1 : 0,
        preAdvise: element.preAdvise ? 1 : 0,
        delivered: element.delivered ? 1 : 0,
        deliveredDate: element.deliveredDate,
        originID: element.originID,
        trucker: element.trucker,
        originCustomer: element.originCustomer,
        origin: element.origin,
        originCity: element.originCity,
        destinationID: element.destinationID,
        destinationCustomer: element.destinationCustomer,
        destinationCity: element.destinationCity,
        commodity: element.commodity,
        destinatticketionID: element.ticketNumber,
        rate: element.rate,
        loadNumDesc: element.loadNumDesc,
        notes: element.notes,
        purchaseContract: element.purchaseContract,
        destUnload: element.destUnload,
        truckerID: element.truckerID,
        maNotes: element.maNotes,
        salesContract: element.salesContract,
        enteredBy: element.enteredBy,
        pq_rowstyle: { 'background-color': this.loadBgColor(element) },
      });
    });

    const exportColModel = [];

    exportColModel.push(
      { title: "Loc",  dataIndx: "locCode",  width: 80, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' }, },
      { title: "Load Date", dataIndx: "loadDate", width: 120, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Delivery Date", dataIndx: "deliveryDate", width: 120, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Load Num",  dataIndx: "loadNumber", width: 120, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Trucker", dataIndx: "trucker",width: 250, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6',   'color': '#ffffff' } },
      { title: "Origin ID",  dataIndx: "originID", width: 100, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "OriginCustomer",  dataIndx: "originCustomer", width: 250, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Origin", dataIndx: "origin",  width: 250, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6',  'color': '#ffffff' } },
      { title: "Origin City",  dataIndx: "originCity", width: 150, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Destination ID", dataIndx: "destinationID", width: 130, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Destination",  dataIndx: "destination", width: 250, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "DestCustomer",  dataIndx: "destinationCustomer", width: 250, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Dest City", dataIndx: "destinationCity", width: 150, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Comm", dataIndx: "commodity", width: 80, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "P/A",  dataIndx: "preAdvise", width: 80, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Dlvd", dataIndx: "delivered", width: 80, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Delivered Date", dataIndx: "deliveredDate", width: 120, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Ticket", dataIndx: "ticket", width: 120, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "F/S", dataIndx: "finalSettled", width: 80, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Rate", dataIndx: "rate", width: 120, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Load Num Desc", dataIndx: "loadNumDesc", width: 150, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Note",  dataIndx: "notes", width: 180, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Purchase Contract", dataIndx: "purchaseContract", width: 150, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Dest Unload #", dataIndx: "destUnload", width: 120, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Trucker ID",  dataIndx: "truckerID", width: 150, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "MA Note", dataIndx: "maNotes", width: 180, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Sales Contract #", dataIndx: "salesContract", width: 150, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Entered By", dataIndx: "enteredBy", width: 150, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
      { title: "Load ID", dataIndx: "loadId", width: 100, styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } }
    );
  
    // Export the data
    const exportOptions = {
      render: true,
      sheetName: "loads",
      format: "xlsx",
      includeCollapsed: true,
      rowData: allData,
      type: 'blob',

    };

    const tempGrid = pq.grid("<div></div>", {
      colModel: exportColModel,
      dataModel: { data: allData },
      numberCell: { show: false },
      scrollModel: { autoFit: false },
      columnBorders: true,
      resizable: true,
    });

    const blob = tempGrid.exportExcel(exportOptions);
    pq.saveAs(blob, 'loads-export.xlsx');
  }


  private loadBgColor(rowData: TicketMaintenanceLoadItem) {
    
    if (rowData.preAdvise && rowData.delivered && rowData.finalSettled) {
      return '#ffd700';
    }
    else if (rowData.finalSettled) {
      return '#ffd700';
    }
    else if (rowData.delivered) {
      return '#ffa07a';
    }
    else if (rowData.preAdvise) {
      return '#009aee';
    }
    return '#ffffff';
  }

  dateEditor(ui) {
    var $inp = ui.$cell.find("input"),
      format = ui.column.format || "mm/dd/yy";
    // val: string = $inp.val(),
    // val = val ? $.datepicker.formatDate(format, new Date(val)) : "";
    const val: string = $inp.val() ? $.datepicker.formatDate(format, new Date($inp.val())) : "";

    //initialize the editor
    $inp.val(val)
      .datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: format,
        showAnim: '',
        onSelect: function () {
          this.firstOpen = true;
        },
        beforeShow: function (input, inst) {
          setTimeout(function () {
            //to fix the issue of datepicker z-index when grid is in maximized state.
            $('.ui-datepicker').css('z-index', 999999999999);
          });
          //return !this.firstOpen; uncomment if don't want to allow datepicker editor to open upon focus in editor after first opening.
        },
        onClose: function () {
          this.focus();
        }
      });
  }

  ngOnDestroy(): void {
    this.loadsGrid.grid.off("filter");
  }

  ngAfterViewInit() {
    // this.loadsGrid.grid.on("filter", () => {
    //   this.updateRecordCountDisplay();
    // });

  }
}
